var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.003-.006L.251 6.615l1.417 1.389 5.336-5.232 5.329 5.225 1.416-1.388z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--chevron-up-eda5202f5ed3585a359001faffc8ed01.svg";
export { SvgIconUiChevronUp as Component };